import axios from "axios";
import Helping from '../helpers/Helping';
import { LOOKUPS } from '../config/urls';

export const addCategories = categories => ({
    type: 'ADD_CATEGORIES',
    categories
})

export const addCurrencies = currencies => ({
    type: 'ADD_CURRENCIES',
    currencies
})

export const addEditions = editions => ({
    type: 'ADD_EDITIONS',
    editions
})

export const addSeries = series => ({
    type: 'ADD_SERIES',
    series
})

export const addSets = sets => ({
    type: 'ADD_SETS',
    sets
})

export const addTypes = types => ({
    type: 'ADD_TYPES',
    types
});

export const addPermutations = permutations => ({
    type: 'ADD_PERMUTATION',
    permutations
});

export const addVariations = variations => ({
    type: 'ADD_VARIATIONS',
    variations
})

export const addBrands = brands => ({
    type: 'ADD_BRAND',
    brands
});

export const addRarities = rarities => ({
    type: 'ADD_RARITY',
    rarities
});

export const addIps = ips => ({
    type: 'ADD_IP',
    ips
});

export const addNftTypes = nfts => ({
    type: 'ADD_NFT_TYPES',
    nfts
});

export const addDlcTypes = dlcTypes => ({
    type: 'ADD_DLC_TYPES',
    dlcTypes
});

export const addAssets = assets => ({
    type: 'ADD_ASSETS',
    assets
});

export const addArtists = artists => ({
    type: 'ADD_ARTISTS',
    artists
});

export const addParentLookups = lookups => ({
    type: 'ADD_PARENT_LOOKUPS',
    lookups
});

export const addArtCollections = artCollections => ({
    type: 'ADD_ART_COLLECTION',
    artCollections
});

export const addLobby = lobby => ({
    type: 'ADD_LOBBY',
    lobby
});

export const addGenre = genre => ({
    type: 'ADD_GENRE',
    genre
});

export const addIllustrator = illustrator => ({
    type: 'ADD_ILLUSTRATOR',
    illustrator
});

export const addWriter = writer => ({
    type: 'ADD_WRITER',
    writer
});

export const fetchLookups = (code) => {
    return dispatch => {
        return axios.get(Helping.getTradingWebApiUrl() + 'base-child?code=' + code).then(response => {
            if (code === "CATEGORY") {
                dispatch(addCategories(response.data.payload.baseChild));
            }

            if (code === "EDITION") {
                dispatch(addEditions(response.data.payload.baseChild));
            }

            if (code === "SERIES") {
                dispatch(addSeries(response.data.payload.baseChild));
            }

            if (code === "VARIATION") {
                dispatch(addVariations(response.data.payload.baseChild))
            }

            if (code === "SET") {
                dispatch(addSets(response.data.payload.baseChild));
            }

            if (code === "TYPE") {
                dispatch(addTypes(response.data.payload.baseChild));
            }

            if (code === "PERMUTATION") {
                dispatch(addPermutations(response.data.payload.baseChild));
            }

            if (code === "BRAND") {
                dispatch(addBrands(response.data.payload.baseChild));
            }

            if (code === "IP") {
                dispatch(addIps(response.data.payload.baseChild));
            }

            if (code === "RARITY") {
                dispatch(addRarities(response.data.payload.baseChild));
            }
        }).catch(error => {
            if (error.response) {
                console.log('in base child: ', error.response);
            }
            return updateCallback({
                ...Helping.setNetworkRequestError(error,`fetching base lookups`)
            });
        });
    }
};

export const fetchAllLookups = () => {
    return dispatch => {
        return Helping.returnPromise().then((value) => {
            return axios.get(LOOKUPS.URL).then(res => {
                console.log('parent: ', res.data.payload);
                dispatch(addParentLookups(res.data.payload));
            }).catch(error => {
                if (error.response) {
                console.log('in base child: ', error.response);
                }
                return updateCallback({
                ...Helping.setNetworkRequestError(error, `fetching base lookups`),
                });
            })
        });
    }           
}

let updateCallback = (res) => {

}


export const setLookupError = (callback) => {

    updateCallback = callback;

}

export const fetchLookupsByLookupId = (lookups, code, id, edition_id = undefined) => {
    return dispatch => {
        if (code === "CATEGORY") {
            dispatch(addCategories([]));
            dispatch(addTypes([]));
            dispatch(addCategories(lookups.filter(lookup => Number(lookup.edition_id) === Number(id))));
        }

        if (code === "EDITION") {
            dispatch(addEditions([]));
            dispatch(addSeries([]));
            dispatch(addCategories([]));
            dispatch(addTypes([]));
            dispatch(addEditions(lookups.filter(lookup => Number(lookup.brand_id) === Number(id))));
        }

        if (code === "SERIES") {
            dispatch(addSeries([]));
            dispatch(addSeries(lookups.filter(lookup => Number(lookup.edition_id) === Number(id))));
        }

        if (code === "VARIATION") {
            dispatch(addVariations([]));
            dispatch(addVariations(lookups.filter(lookup => Number(lookup.brand_id) === Number(id))))
        }

        if (code === "SET") {
            dispatch(addSets([]));
            dispatch(addSets(lookups.filter(lookup => Number(lookup.brand_id) === Number(id))));
        }

        if (code === "TYPE") {
            dispatch(addTypes([]));
            dispatch(addTypes(lookups.filter(lookup => Number(lookup.category_id) === Number(id) && Number(lookup.edition_id) === Number(edition_id))));
        }

        if (code === "ARTIST") {
            dispatch(addArtists([]));
            dispatch(addArtists(lookups.filter(lookup => Number(lookup.brand_id) === Number(id))));
        }

        if (code === "ART_COLLECTION") {
            dispatch(addArtCollections([]));
            dispatch(addArtCollections(lookups.filter(lookup => Number(lookup.artist_id) === Number(id))));
        }

        if (code === "BRAND") {
            dispatch(addBrands([]));
            dispatch(addSets([]));
            dispatch(addEditions([]));
            dispatch(addSeries([]));
            dispatch(addCategories([]));
            dispatch(addTypes([]));
            dispatch(addVariations([]));
            dispatch(addBrands(lookups.filter(lookup => Number(lookup.nft_type_id) === Number(id))));
        }

        if (code === "IP") {
            dispatch(addIps(lookups));
        }

        if (code === "RARITY") {
            dispatch(addRarities([]));
            dispatch(addRarities(lookups));
        }
    }
};

export const emptyLookups = () => {
    return dispatch => {
        dispatch(addIps([]));
        dispatch(addBrands([]))
        dispatch(addTypes([]));
        dispatch(addSets([]));
        dispatch(addVariations([]));
        dispatch(addSeries([]));
        dispatch(addEditions([]));
        dispatch(addCategories([]));
    }
};